import styles from './CategorySkeleton.module.scss';

interface CategorySkeletonProps {
  count?: number;
}

const CategorySkeleton = ({ count = 6 }: CategorySkeletonProps) => {
  return (
    <>
      {Array.from({ length: count }, (_, index) => (
        <li key={index} className={styles.categorySkeleton}>
          <div className={styles.iconSkeleton} />
          <div className={styles.infoSkeleton}>
            <div className={styles.titleSkeleton} />
            <div className={styles.countSkeleton} />
          </div>
        </li>
      ))}
    </>
  );
};

export default CategorySkeleton;
